import requireAll from 'helpers/requireAll';

const fetchLangs = () => require.context('./translations/', true, /^\.\/.*\.js$/);
const translations = requireAll(fetchLangs(), 'locale/translations');
const translationMap = {};
const localeMap = {};
const formalLocaleName = locale => {
    const lang = locale.substr(0, 2);
    const region = locale.substr(2, 2);

    return {
        name: (region ? `${ lang }-${ region }` : lang),
        lang,
    };
};

Object.keys(translations).forEach(key => {
    const [locale, groupName] = key.split('$');
    const { name, lang } = formalLocaleName(locale);

    // bind translation map
    if (groupName === 'index') {
        translationMap[name] = {
            ...translationMap[name],
            ...translations[key],
        };
    }
    else {
        translationMap[name] = {
            ...translationMap[name],
            [groupName]: translations[key],
        };
    }

    if (name !== lang) {
        translationMap[lang] = {
            ...translationMap[name],
        };
    }

    // bind locale map
    localeMap[name] = {
        locale: name,
        exact: true,
    };

    if (lang !== name) {
        localeMap[lang] = {
            locale: lang,
            exact: false,
        };
    }
});
export const defaultLanguage = 'zh-TW';
export const getLocaleMap = () => localeMap;

export const getTranslations = () => {
    return translationMap;
};
